export enum VIEW {
  FIRST_LAYER = 'FIRST_LAYER',
  NONE = 'NONE',
  PRIVACY_BUTTON = 'PRIVACY_BUTTON',
  SECOND_LAYER = 'SECOND_LAYER',
}

export enum GLOBAL_EVENTS {
  INITIALIZED = 'UC_UI_INITIALIZED',
  VIEW_CHANGED = 'UC_UI_VIEW_CHANGED',
}

export enum ERROR_MESSAGES {
  SERVICE_MISSING_ID = 'Usercentrics: service ID is missing',
  DUPLICATED_SCRIPT = 'Usercentrics: duplicated script tag',
  TCF_NOT_ENABLED = 'Usercentrics: TCF is not enabled',
  CLIENT_CONFIG_NOT_AVAILABLE = 'AMP clientConfig is not available',
}
